import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import { ErrorKeys } from 'consts/errorKeys'

export const getDataByType = (type: ErrorKeys) => {
  return {
    [ErrorKeys.NOT_FOUND_PROJECT]: {
      title: translate(T.SOMETHING_WENT_WRONG_LABEL),
      description: translate(T.NOT_FOUND_PROJECT_ERROR_MESSAGE)
    },
    [ErrorKeys.GENERAL_API_ERROR]: {
      title: translate(T.SOMETHING_WENT_WRONG_LABEL),
      description: translate(T.GENERAL_API_ERROR_MESSAGE)
    },
    [ErrorKeys.PROJECT_MAX_DURATION_EXCEEDED]: {
      title: translate(T.PROJECT_MAX_DURATION_EXCEEDED_TITLE),
      description: translate(T.PROJECT_MAX_DURATION_EXCEEDED_DESCRIPTION)
    },
    [ErrorKeys.AI_VIDEO_GENERATION_FAILED]: {
      title: translate(T.AI_VIDEO_GENERATION_FAILED_TITLE),
      description: translate(T.AI_VIDEO_GENERATION_FAILED_DESCRIPTION)
    },
    [ErrorKeys.AI_IMAGE_GENERATION_FAILED]: {
      title: translate(T.GENERATION_FAILED),
      description: translate(T.AI_IMAGE_GENERATION_FAILED_DESCRIPTION)
    },
    [ErrorKeys.AI_MODERATION_FAILED]: {
      title: translate(T.AI_MODERATION_FAILED_TITLE),
      description: translate(T.AI_MODERATION_FAILED_DESCRIPTION)
    },
    [ErrorKeys.CUSTOM_API_ERROR]: {
      title: translate(T.SOMETHING_WENT_WRONG_LABEL)
    }
  }[type]
}
